<template>
<div class="a__recruit" id="a__recruit">
  <div class="top_image">
    <div class="top_contents">
      <TextAnime3 v-if="anime1"/>
      <TextAnime4 v-if="anime2"/>
    </div>
  </div>

  <div class="w__benefits" id="w__benefits">
    <div class="w_title">
      <div class="recruit_title">
        <p class="subtitle">福利厚生</p>
        <h2 class="title">Benefits</h2>
        <p class="content">充実の福利厚生でエンジニアの嬉しいをサポートします。<br>
        社員の家庭を大切にしたいという思いから、Weboarでは特に家族や子育てのための福利厚生に力をいれています。</p>
      </div>
    </div>
    <div class="w_content">
      <div class="benefits">
        <div class="benefit">
            <img src="../../assets/benefits/benefits_1.png">
          <div class="content">
            <h3>各種手当</h3>
            <ul>
              <li>通勤手当</li>
              <li>住宅手当</li>
              <li>家族手当</li>
              <li>リモートワーク手当</li>
            </ul>
          </div>
         </div>
         <div class="benefit">
          <img src="../../assets/benefits/benefits_2.png">
          <div class="content">
            <h3>学習補助</h3>
            <ul>
              <li>勉強会参加手当</li>
              <li>資格取得手当</li>
              <li>書籍購入補助制度</li>
            </ul>
          </div>
         </div>
         <div class="benefit">
          <img src="../../assets/benefits/benefits_3.png">
          <div class="content">
            <h3>育児補助</h3>
            <ul>
              <li>配偶者出産時の有給付与制度</li>
              <li>育児のための時短勤務選択制度</li>
              <li>緊急時子連れ出社制度</li>
              <li>妊娠中の従業員が母子健康法の定める健康診査のため、勤務時間内に通院する必要がある場合の外出許可制度</li>
            </ul>
          </div>
         </div>
         <div class="benefit">
          <img src="../../assets/benefits/benefits_4.png">
          <div class="content">
            <h3>災害回避</h3>
            <ul>
              <li>災害時（台風・地震など）に通勤が難しい場合はRWを選択可能</li>
            </ul>
          </div>
         </div>
         <div class="benefit">
          <img src="../../assets/benefits/benefits_6.png">
          <div class="content">
            <h3>飲食充実</h3>
            <ul>
              <li>社員が自由に飲めるドリンクを常備</li>
              <li>毎月の社内ピザパーティーではピザとお酒を提供</li>
            </ul>
          </div>
         </div>
         <div class="benefit">
          <img src="../../assets/benefits/benefits_7.png">
          <div class="content">
            <h3>特別休暇</h3>
            <ul>
              <li>バースデー休暇</li>
              <li>リフレッシュ休暇（3年毎に連続した5日間の休暇を付与）</li>
            </ul>
          </div>
         </div>
      </div>
    </div>
  </div>

    <div class="w__jobtype" id="w__jobtype">
      <div class="w_title">
        <div class="recruit_title">
          <p class="subtitle">募集職種</p>
          <h2 class="title">Job info</h2>
          <p class="content">各エンジニアを積極的に採用中です。</p>
        </div>
      </div>
      <div class="jobinfo_image">
        <img src="../../assets/recruit_2.png">
      </div>

      <div class="job_type">
        <input id="acd_1" class="acd-job" type="checkbox">
        <label class="acd-ya" for="acd_1">
          <div class="w_card">
            <div class="job_name">
              <p class="jobtype_text">エンジニア</p>
              <div class="mark">積極採用中</div>
            </div>
            <div class="btn" id="job_btn"><p id="job_text">+</p></div>
          </div>
        </label>

        <div class="acd_content">
          <div class="acd-content1">
            <div class="add_back">
            <p>フロントエンドエンジニア</p>
            <p>バックエンドエンジニア</p>
            <p>インフラエンジニア</p>
          </div>
          </div>
        </div>



        <div class="job_card single">
          <div class="w_card">
            <div class="job_name">
              <p>デザイナー</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import TextAnime3 from '../animation/TextAnime3'
import TextAnime4 from '../animation//TextAnime4'
export default {
  components: {
    TextAnime3,
    TextAnime4,
  },
  name: 'Top',
  data() {
    return {
       anime1: true,
       anime2: true,
    }
  }
}
$(function(){
    $(".acd-ya").on("click", function (evt) {
      chk_status = $("#acd_1").prop("checked");
      if(chk_status){
        $("#job_btn").css("background-color", "white");
        $("#job_text").css("color", "#b55746");
        $("#job_text").css("line-height", "15px");
        $("#job_text").text("+");
      }else{
        $("#job_btn").css("background-color", "#b55746");
        $("#job_text").css("color", "white");
        $("#job_text").css("line-height", "16px");
        $("#job_text").text("-");
      }
    });
});
</script>

<style scoped>

.a__recruit .top_image .top_contents {
  position: absolute;
  bottom: 46px;
  left: 82px;
  text-align: left;
}

.a__recruit .top_image .top_contents .TextAnime1 {
  margin-top: 18px;
}

.a__recruit .top_image .top_contents p.top_content {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
}

.acd-job{
    display: none;
}
.acd-ya{
    height: 60px;
    background: #fff8f0;
    color: #333;
    display: block;
    padding: 10px;
    border-radius: 8px;
}

.acd-ya:hover {
  background-image: linear-gradient(136deg, #fee140, #fdb960 15%, #fcaa6c 33%, #fa709a);
  cursor: pointer;
  color: #fff;
}

.acd-ya .w_card {
  display: flex;
  justify-content: space-between;
}

.acd-ya .w_card .job_name {
  display: flex;
  margin-left: 29px;
}

.acd-ya .w_card .job_name .jobtype_text {
  line-height: 32px;
}

.acd-ya .w_card .job_name .mark {
  width: 65px;
  height: 16px;
  border-radius: 10px;
  background-color: #f12c71;
  color: #fff;
  font-size: 10px;
  margin-top: 23px;
  margin-left: 12px;
  line-height: 16px;
}

.acd-ya .w_card .btn {
  width: 17px;
  height: 17px;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 23px;
  margin-right: 34px;
  z-index: 3;
  box-shadow: 0 1px 0 rgba(0,0,0,.1);
  font-weight: bold;
}

.acd-ya .w_card .btn p {
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: #b55746;
}

.acd_content{
  background: #fff8f0;
  height: 0;
  opacity: 0;
  padding: 0 10px;
  transition: .5s;
  visibility: hidden;
}

.acd_content .acd-content1 {
  background: #fff;
}

.acd_content .acd-content1 .add_back{
  justify-content: left;
  display: flex;
  flex-wrap: wrap;
}

.acd_content .acd-content1 .add_back p {
  display: inline-block;
  width: 43%;
  text-align: left;
  padding-left: 28px;
  font-size: 14px;
}

.acd-job:checked + .acd-ya + .acd_content{
  height: 98px;
  opacity: 1;
  padding: 10px;
  visibility: visible;
}

.acd-job:checked ~ .acd-ya {
  border-radius: 8px 8px 0 0 ;
}

.acd-job:checked ~ .acd-ya:hover {
  background-image: none;
  color: #555;
}


.a__recruit {
  width: 100%;
  position: relative;
  top: -24px;
  border-left: #d8d8d8 solid 1px;
  padding-bottom: 90px;
}

.a__recruit .top_image {
  width: 93%;
  position: relative;
  height: calc(69vh - 1.5em * 2);
  background-image: url("../../assets/jobinfo.jpg");
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  border-radius: 0 0 8px 0;
}

.a__recruit .w__benefits {
  padding: 2px 86px 0px 82px !important;
  max-width: 1250px;
  margin: 40px auto 0;
  display: block;
}

.a__recruit .w__benefits .w_title .recruit_title {
  display: block;
  text-align: left;
  padding-bottom: 48px;
  width: 100%;
}

.a__recruit .w__benefits .w_title .recruit_title .subtitle {
  margin-bottom: 0;
}

.a__recruit .w__benefits .w_title .recruit_title .title {
  font-size: 24px;
}

.a__recruit .w__benefits .w_title .recruit_title .title {
  margin: 4px 0 0;
}

.a__recruit .w__benefits .w_content {
  width: 100%;
  display: block;
}

.a__recruit .w__benefits .w_content .benefits {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.a__recruit .w__benefits .w_content .benefits .benefit {
  width: 48%;
  display: flex;
  margin-bottom: 24px;
}

.a__recruit .w__benefits .w_content .benefits .benefit .w_image {
  height: 100%;
}

.a__recruit .w__benefits .w_content .benefits .benefit img {
  width: 132px;
  height: 132px;
  display: inline-block;
  border-radius: 70px;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
}

.a__recruit .w__benefits .w_content .benefits .benefit .content {
  display: inline-block;
  margin-left: 34px;
}

.a__recruit .w__benefits .w_content .benefits .benefit h3 {
  color: #222;
  font-size: 13px;
  margin: 10px 0 0;
}

.a__recruit .w__benefits .w_content .benefits .benefit ul {
  padding-left: 14px;
  width: 100%;
  margin-top: 12px;
}

.a__recruit .w__benefits .w_content .benefits .benefit li {
  color: #555;
  font-size: 12px;
}

.a__recruit .w__benefits .w_content .benefits .benefit p {
  color: #555;
  font-size: 11px;
  margin-top: 4px;
}

.a__recruit .w__jobtype {
  padding: 40px 86px 0px 82px !important;
  max-width: 1250px;
  margin: 0 auto;
}

.a__recruit .w__jobtype .job_type {
  width: 100%;
}

.a__recruit .w__jobtype .job_type .job_card {
  width: 100%;
  height: 68px;
  padding-top: 12px;
  border-radius: 8px;
  background-color: #fff8f0;
  transition: background-image 1s;
  position: relative;
  margin-top: 2px;
}

.acd-check{
  display: none;
}
.acd-label{
  display: block;
}

.a__recruit .w__jobtype .job_type .job_card .w_card {
  display: flex;
  justify-content: space-between;
  padding-left: 38px;
}

.a__recruit .w__jobtype .w_title .recruit_title {
  display: block;
  text-align: center;
  padding-bottom: 32px;
  width: 100%;
}

.a__recruit .w__jobtype .w_title .recruit_title p.subtitle{
  margin-bottom: 8px;
}

.a__recruit .w__jobtype .w_title .recruit_title h2.title {
  margin: 0px;
}

.a__recruit .w__jobtype .w_title .recruit_title p.content {
  margin-top: 0;
  margin-bottom: 0;
  text-align: center;
}

.a__recruit .w__jobtype .w_title .recruit_title .title {
  font-size: 34px;
  margin: 8px 0 32px
}

.a__recruit .w__jobtype .jobinfo_image {
  width: 100%;
  margin-bottom: 48px;
}

.a__recruit .w__jobtype .jobinfo_image img {
  width: 100%;
  border-radius: 20px;
}

.a__recruit .top_image .top_contents .TextAnime1 {
  width: 90%;
}

@media screen and (max-width:1024px) {

  .a__recruit .top_image {
    width: 100%;
    border-radius: 0;
  }

  .a__recruit .w__title .title {
    margin-top: 0;
  }

  .a__recruit .w__benefits {
    padding-top: 40px !important;
  }

  .a__recruit .w__benefits .w_content .benefits .benefit img {
    width: 100px;
    height: 100px;
  }
}

@media screen and (max-width:769px) {
  .a__recruit .w__title {
    width: 90%;
    margin: 0 auto;
    padding: 0;
  }

  .a__recruit .w__jobtype {
    width: 90%;
    margin: 0 auto !important;
    padding: 0 !important;
  }

  .a__recruit .w__benefits {
    width: 90%;
    margin: 0 auto !important;
    padding: 0 !important;
  }

  .acd-job:checked + .acd-ya + .acd_content {
    height: 146px;
  }

  .acd_content .acd-content1 .add_back p {
    display: block;
    width: 100%;
  }

  .a__recruit .w__title .content p.content {
    margin-bottom: 24px;
  }

  .a__recruit .w__jobtype .w_title .recruit_title .subtitle {
    margin-top: 24px;
  }

  .a__recruit .top_image .top_contents {
    bottom: 40px;
    left: 32px;
  }

  .a__recruit .w__benefits .w_content .benefits .benefit ul {
    width: auto;
  }

  .a__recruit .w__benefits .w_title .recruit_title {
    padding: 16px 0;
  }

  .a__recruit .w__benefits .w_title .recruit_title p.content {
    margin-top: 12px !important;
  }
}


@media screen and (max-width:640px) {
  .a__recruit .w__benefits {
    width: 90%;
  }

  .a__recruit .w__value .top_image {
    height: 240px;
  }

  .a__recruit .w__benefits .w_content .benefits .benefit {
    display: flex;
    width: 100%;
  }
}

@media screen and (max-width: 480px) {

  .a__recruit .w__benefits .w_content .benefits .benefit img {
    width: 100px;
    height: 100px;
  }

  .a__recruit .w__benefits .w_content .benefits .benefit .content {
    width: 72%;
  }

  p.content {
    margin-top: 33px !important;
    font-size: 12px;
  }

  h2.title {
    font-size: 24px;
  }

  .a__recruit .w__title .title .line {
    margin: 34px 30px 0;
  }

  a__recruit .w__title .title .content {
    margin-top: 33px ;
  }

  .a__recruit .w__jobtype .w_title .recruit_title{
    padding-bottom: 16px;
  }

  .a__recruit .w__jobtype .w_title .recruit_title .subtitle {
    margin-bottom: 0;
  }

  .a__recruit .w__jobtype .w_title .recruit_title .title {
    margin: 8px 0 14px;
  }

  .a__recruit .w__jobtype .w_title .recruit_title p.content {
    margin-top: 14px !important;;
  }

  .a__recruit {
    padding-bottom: 40px;
  }

  .a__recruit .w__jobtype .jobinfo_image {
    margin-bottom: 24px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/pages/Recruit.vue